import axios from "axios";
import state from "../store";

const baseURL = state.getters.mainAppURL + "dashboard/";
const getGlobalStats = (params) => axios.get(baseURL + "global_stats", {params});

const getDateWiseOrderCount = (params) => axios.get(baseURL + "date_wise_count", { params });

const getDateWiseSale = (params) => axios.get(baseURL + "date_wise_sales", { params });

const getAverageOrdersCountandValuePerMonth = (params) => axios.get(baseURL + "average_orders_count_and_value_per_day", { params });

const getTopProducts = (params) => axios.get(baseURL + "products_sale_stats", {params });

const getTopCancellationReasons = (params) => axios.get(baseURL + "top_cancellation_reasons", {params });

const getCityWiseOrderSalesNumber = (params) => axios.get(baseURL + "city_wise_order", {params });

const getTopSellingAreas = (params) => axios.get(baseURL + "top_selling_areas", { params });

const getBranchWiseOrderSum = (params) => axios.get(baseURL + "branch_wise_order_sum", { params });

const getSaleOfLastSixMonth = (params) => axios.get(baseURL + "monthly_sales", { params });
const getNewCustomers = (params) => axios.get(baseURL + "monthly_new_customers", { params });


export {
    getGlobalStats,
    getDateWiseOrderCount,
    getDateWiseSale,
    getBranchWiseOrderSum,
    getTopProducts,
    getAverageOrdersCountandValuePerMonth,
    getTopSellingAreas,
    getTopCancellationReasons,
    getCityWiseOrderSalesNumber,
    // getAverageOrdersValuePerDay,
    //getTopCustomers,
    getNewCustomers,
    //getOrderTypeStats,
    getSaleOfLastSixMonth,
    //getMonthlyAgentStats
}


// const getTopCustomers = (params) => axios.get(baseURL + "customer_stats", { params });


// const getOrderTypeStats = (params) => axios.get(baseURL + "takeAway_delivery_orders_count", { params });

// const getMonthlyAgentStats = (params) => axios.get(baseURL + "agent_stats?"+params);